import SectionHeading from "@/pages/home/components/SectionHeading";
import { featuredTopics } from "@/mocks/featured";

function formatHeat(n: number) {
  return n >= 10000 ? `${(n / 10000).toFixed(1)} 万` : n.toString();
}

export default function Spotlight() {
  return (
    <section id="spotlight" className="w-full bg-background-50 px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-shell mx-auto">
        <SectionHeading
          index="01"
          eyebrow="焦点速览"
          title="今天最值得慢慢读的三件事"
          desc="每一件都附上原始出处与时间线，先看结论，再看它怎么一步步走到这里。"
          actionLabel="查看全部焦点"
          actionHref="#trending"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
          {featuredTopics.map((topic, idx) => (
            <article
              key={topic.id}
              className="group flex flex-col rounded-lg border border-background-200/80 bg-background-100/40 overflow-hidden transition-colors hover:border-primary-300 cursor-pointer"
              style={{ animationDelay: `${idx * 90}ms` }}
            >
              <div className="relative w-full h-48 md:h-52 overflow-hidden bg-background-200">
                <img
                  src={topic.image}
                  alt={`${topic.title} 深度解读配图`}
                  title={`黑料看点 - ${topic.tag}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 rounded-full bg-background-50/90 px-3 py-1 text-[11px] font-medium text-primary-700">
                  {topic.tag}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-700 transition-colors">
                  {topic.title}
                </h3>
                <p className="mt-2.5 text-sm text-foreground-500 leading-relaxed flex-1">
                  {topic.summary}
                </p>
                <div className="mt-4 pt-4 border-t border-background-200/80 flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-user-voice-line" />
                    {topic.source}
                  </span>
                  <span className="flex items-center gap-3">
                    <span className="flex items-center gap-1">
                      <i className="ri-fire-line text-accent-500" />
                      {formatHeat(topic.heat)}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line" />
                      {topic.comments}
                    </span>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}